import type { IFile } from '@/types/globalTypes'
import { EFileCollection } from '@/modules/productModule/constants/productConstants'

const groupPrefix = 'cms-locations-content'

export const apiCMSLocationsContent = {
	fetchCMSLocationContent: async (cmsLocationContentID: number) => {
		const { data } = await apiCommon<ICMSLocationContent>(`${groupPrefix}/${cmsLocationContentID}`, { method: 'GET' })
		return CMSLocationContentFromJSON(data)
	},

	fetchCMSLocationContentSections: async (cmsLocationID: number, lang?: string) => {
		let url = `${groupPrefix}/locations/${cmsLocationID}`

		if (lang) {
			url += `?lang=${lang}`
		}

		const { data } = await apiCommon<ICMSLocationContent[]>(url, { method: 'GET' })

		if (!data) return { data: [] }
		const response = data.map((location) => {
			return CMSLocationContentFromJSON(location)
		})
		return { data: response }
	},

	updateCMSLocationContent: async (locationData: ICMSLocationContentModel, cmsLocationContentID: number) => {
		const { data } = await apiCommon<ICMSLocationContent>(`${groupPrefix}/${cmsLocationContentID}`, {
			method: 'PUT',
			body: CMSLocationContentToJSON(locationData),
		})
		return CMSLocationContentFromJSON(data)
	},

	// for files
	uploadCMSLocationContentImage: async (newsID: number, file: File, collection: EFileCollection) => {
		const formData = new FormData()
		formData.append('file', file, file.name)
		formData.append('collection', collection)

		const { data } = await apiCommon<{ data: IFile }>(`files/CMSLocationContent/${newsID}`, {
			method: 'POST',
			body: formData,
		})
		return FileFromJSON(data)
	},
}
